import React, {useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    FORM,
    MAX_NAME,
    REQUIRED,
} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import Switch from "react-bootstrap-switch";
import {utilHelper} from "../../../jwt/_helpers";
import {categoryProvider} from "../../../providers/categoryProvider";
import ServicesLangs from "./_langs";
import * as Yup from "yup";
import {MAX_NAME_SIZE} from "../../../components/menu-flower/constants";
import {ErrorMessage, useForm} from "react-hook-form";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";
import {setForm, setItem} from "../../../redux/actions/generalActions/formActions";
import {save, update} from "../../../redux/actions/eventx/typeServicesActions";
import {connect} from "react-redux";
import {FL_CATEGORY} from "../../../components/i18n/formLabels";
import SelectGeneric from "../../../components/select/selectGeneric";

function ServicesForm(props) {

    const { editMode, domainObject } = props.formProps;
    const { udn } = props.mainProps;
    const fbDataBaseId = props.mainProps?.app?.fbDataBase?.id
    const [langs, setLangs] = useState(domainObject?.langs || []);
    const [status, setStatus] = useState(domainObject?.status || false);
    const [categoryId, setCategoryId] = useState(  domainObject?.category?.id || null);
    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(domainObject);
    }

    const validationSchema = Yup.object().shape({
        code: Yup.string().required(REQUIRED).max(MAX_NAME_SIZE, MAX_NAME)
    });

    const {register, handleSubmit, reset, errors} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id: domainObject?.id,
            code: domainObject?.code,
            icon: domainObject?.icon,
            colorHex: domainObject?.colorHex
        }
    });

    const handleSwitchChange = () => {
        setStatus(!status);
    }

    const onSubmit = (data, _) => {
        // if (categoryId == null)
        //     return showToastCustom(error, selectOption);

        let dataRequest = {
            noDb : false,
            allDb : false,
            fbDataBase :  { id : fbDataBaseId },
            item : {
                ...data,
                id: domainObject?.id,
                uid: domainObject?.uid,
                status: status,
                colorHex: data.colorHex,
                colorRgb: utilHelper.hexToRGB(data.colorHex),
                udn: { id: udn.id },
                langs: langs
            }
        };

        if (categoryId != null)
            dataRequest.item.category = { id : categoryId };

        try{
            if (editMode) {
                let id = domainObject.id;

                props.update(id, dataRequest)
            } else {
                props.save(dataRequest)
            }
            closeForm()
        } catch (error) {
            console.log(error)
        }

        closeForm()
    };

    const closeForm = () => {
        reset();
        props.setItem(null);
        props.setForm();
        props.onClose()
    }

    return (
        <Card>
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label>Codigo</Label>
                                <Input type="text" name="code"
                                       placeholder=" Código"
                                       innerRef={register}
                                       className={(errors.code ? ' is-invalid' : '')}
                                />
                                <ErrorMessage errors={errors} name="code" component="div"
                                              className="invalid-feedback"/>
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>Icono</Label>
                                <Input type="text" name="icon"
                                       placeholder="Icono"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>Color</Label>
                                <br/>
                                <Input type="color" name="colorHex"
                                       innerRef={register}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="2">
                            <FormGroup>
                                <Label>Activo</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        onChange={handleSwitchChange}
                                />
                            </FormGroup>
                        </Col>

                    </Row>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>{ FL_CATEGORY }</Label>
                                <SelectGeneric
                                    initialValue={ categoryId }
                                    setExternalValue={ value =>  setCategoryId(value) }
                                    provider = { categoryProvider }
                                    resetValue={ false }
                                />
                            </FormGroup>
                        </Col>
                    </Row>
                    <CardTitle className="bg-light border-bottom p-3 mb-0">
                        <i className="fas fa-language mr-2"/>
                        Información internacional
                    </CardTitle>
                    <CardBody>
                        <ServicesLangs langs={langs} setLangs={setLangs} />
                    </CardBody>
                    <CardBody className="border-top">
                        <div className="float-right">
                            <ButtonSubmit/>
                            <ButtonCancel onClick={closeForm}/>
                        </div>
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ domainObject }
                />
            }
        </Card>
    )
}

const mapStateToProps = state => ({
    mainProps: state.mainProps,
    formProps: state.formProps,
})

const mapActionsToProps = ({
    setItem,
    setForm,
    save,
    update,
})

export default connect(mapStateToProps, mapActionsToProps)(ServicesForm)